<template>
  <v-row>
    <v-col md="5" class="align-center">
      <v-img
        :src="require('@/assets/images/login_image.png')"
        class="mx-auto mb-8"
        width="400"
      />
    </v-col>
    <v-col md="7" class="d-flex align-center">
      <div class="flex-fill">
        <h1 class="text-center mb-2">
          ورود به سامانه
        </h1>
        <p class="text-center">
          اگر قبلا ثبت نام کرده اید؛ برای ورود به سامانه نام کاربری و کلمه عبور
          خود را وارد نمایید
        </p>
        <v-card outlined class="pa-5">
          <form-alert
            v-if="this.$store.getters.error"
            :message="this.$store.getters.error.message.message"
          />
          <v-form
            v-model="valid"
            @submit.prevent="handleSigninUser"
            class="text-center"
          >
            <v-text-field
              class="mb-3"
              v-model="username"
              :rules="usernameRules"
              outlined
              dense
              label="شماره موبایل"
              required
            />
            <v-text-field
              class="mb-3"
              v-model="password"
              :rules="passwordRules"
              type="password"
              outlined
              dense
              label="کلمه عبور"
              required
            />
            <div class="d-flex mt-2">
              <v-btn
                :loading="this.$store.getters.loading"
                :disabled="!valid || this.$store.getters.loading"
                depressed
                color="success"
                type="submit"
                class="flex-grow-1"
              >
                ورود به سامانه
              </v-btn>
              <v-btn
                color="primary"
                depressed
                outlined
                class="mr-2"
                router
                to="Register"
              >
                ثبت‌نام نکرده‌اید؟
              </v-btn>
            </div>
          </v-form>
          <v-btn
            color="grey"
            depressed
            text
            block
            class="mt-2 mr-2"
            router
            to="ForgotPassword"
          >
            فراموشی رمز عبور
          </v-btn>
        </v-card>
      </div>
    </v-col>
    <v-col cols="12" class="text-center">
      <v-btn class="mt-2" router to="/" text>
        بازگشت به صفحه اصلی
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "signin-component",
  data: () => {
    return {
      navbar: false,
      loading: false,
      valid: true,
      username: "",
      usernameRules: [
        (u) => !!u || "لطفا تلفن همراه خود را وارد نمایید",
        (u) => (u && u.length == 11) || "تلفن همراه را به درستی وارد نمایید"
      ],
      password: "",
      passwordRules: [(p) => !!p || "کلمه عبور خود را وارد نمایید"]
    };
  },
  methods: {
    handleSigninUser() {
      this.$store.dispatch("signinUser", {
        username: this.username,
        password: this.password
      });
    }
  }
};
</script>
